<template>
    <ButtonPrimary color="violet" :onClick="handleRegister">
        {{ t({ key: 'sembonus.yes_i_want_bonus_nights' }) }}
    </ButtonPrimary>

    <ButtonText size="m" color="black" :onClick="handleLogin">
        {{ t({ key: 'sembonus.already_member_login' }) }}
    </ButtonText>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent } from 'vue';
    import { AuthModalStep } from '@/components/shared/CompanyHeader/CompanyHeader.interfaces';
    import { logStatsigCheckoutSembonusInteraction } from '@/tracking/statsig/checkout.functions';
    import ButtonText from '@ui/components/Button/ButtonText.vue';
    import ButtonPrimary from '@ui/components/Button/ButtonPrimary.vue';

    export default defineComponent({
        name: 'Actions',
        methods: { t },
        components: { ButtonPrimary, ButtonText },
        setup() {
            function openAuthModal(origin: string, step: string) {
                window.dispatchEvent(
                    new CustomEvent('semboShowAuthModal', {
                        detail: { origin, step },
                        bubbles: true,
                    })
                );
            }

            function handleLogin() {
                openAuthModal('checkout-sembonus', AuthModalStep.LOGIN);
                logStatsigCheckoutSembonusInteraction('Login');
            }

            function handleRegister() {
                openAuthModal('checkout-sembonus', AuthModalStep.REGISTER);
                logStatsigCheckoutSembonusInteraction('SignUp');
            }

            return {
                handleLogin,
                handleRegister,
            };
        },
    });
</script>
